$(function () {
    // click event for subscription form
    $('.subs-form').submit(function (e) {
        e.preventDefault();

        var hNewsLetter = $(this).find('#emailFeedCodeName');
        var subFormRow = $(this).find('.sub-form-row');
        var txtEmail = $(this).find('.sf-email-input');
        var fName = $(this).find('.sf-fn-input');
        var lName = $(this).find('.sf-ln-input');
        var title = $('.subs-widget').find('.sf-title');
        var spanMsg = $('.subs-widget').find('.sf-error-message');
        var aoi = [];
        var hdnGoogleRecaptcha = $(this).find('#hdnGoogleRecaptcha');
        var hdnGrcSiteKey = $(this).find('#grc-site-key');

        $("input:checkbox[name=areaofinterest]:checked").each(function () {
            aoi.push($(this).val());
        });

        // email field is validated on client side so we can localize the response, can't do that in js.
        // submit the form via ajax and recaptcha
        grecaptcha.ready(function () {
            grecaptcha.execute(hdnGrcSiteKey.val(), { action: 'signup' }).then(function (token) {
                hdnGoogleRecaptcha.val(token);
                $.post("/Subscription/Subscribe",
                    {
                        'firstName': fName.val(),
                        'lastName': lName.val(),
                        'emailAddress': txtEmail.val(),
                        'areaOfInterest': aoi,
                        'emailFeedCodeName': hNewsLetter.val(),
                        'recaptchaToken': hdnGoogleRecaptcha.val()
                    })
                    .done(function (result, status, xhr) {
                        var data = JSON.parse(result);

                        if (data.IsError) {
                            spanMsg.addClass("field-validation-error");
                            spanMsg.html(data.ResultMessage);
                            spanMsg.removeClass("d-none")
                            subFormRow.show();
                        } else {
                            spanMsg.removeClass("field-validation-error");
                            spanMsg.html('');
                            spanMsg.addClass("d-none")
                            subFormRow.hide();
                            title.html(data.ResultMessage);
                        }
                    })
                    .fail(function (xhr, status, error) {
                        spanMsg.addClass("field-validation-error");
                        spanMsg.html(xhr.responseText);
                        spanMsg.removeClass("d-none");
                    });
            });
        });
    });
})
